export default "__VITE_ASSET__B38500Oe__"